/* eslint-disable */
// Auto-generated by scripts/codegen/generate-route/generate-routes.mjs — DO NOT EDIT

import { createBrowserClient, registerBrowserService } from "#browser-client.js";
import type { CommonClientApi } from "#api";

import type { ConfigurationServiceApi } from "../../../../services/configuration-service/api.js";
import type { AuthServiceApi } from "../../../../services/auth-service/api.js";

export interface BrowserMasterApiClient {
  "auth": {
    logout: (payload?: Record<string, unknown>, options?: CommonClientApi.BrowserCallOptions) => Promise<AuthServiceApi.Http.Logout.Response>;
    generateCompanyToken: (payload: { [K in keyof AuthServiceApi.Http.GenerateCompanyToken.Request]?: AuthServiceApi.Http.GenerateCompanyToken.Request[K] }, options?: CommonClientApi.BrowserCallOptions) => Promise<AuthServiceApi.Http.GenerateCompanyToken.Response>;
    generateConsoleToken: (payload?: Record<string, unknown>, options?: CommonClientApi.BrowserCallOptions) => Promise<AuthServiceApi.Http.GenerateConsoleToken.Response>;
    updateMyself: (payload: { [K in keyof AuthServiceApi.Http.UpdateMyself.Request]?: AuthServiceApi.Http.UpdateMyself.Request[K] }, options?: CommonClientApi.BrowserCallOptions) => Promise<AuthServiceApi.Http.UpdateMyself.Response>;
    changeMyPassword: (payload: { [K in keyof AuthServiceApi.Http.ChangeMyPassword.Request]?: AuthServiceApi.Http.ChangeMyPassword.Request[K] }, options?: CommonClientApi.BrowserCallOptions) => Promise<AuthServiceApi.Http.ChangeMyPassword.Response>;
    getMyConfiguration: (payload?: Record<string, unknown>, options?: CommonClientApi.BrowserCallOptions) => Promise<AuthServiceApi.Http.GetMyConfiguration.Response>;
  };
  "configuration": {
    getActiveCompaniesForUser: (payload?: Record<string, unknown>, options?: CommonClientApi.BrowserCallOptions) => Promise<ConfigurationServiceApi.Http.GetActiveCompaniesForUser.Response>;
    getWhatsNew: (payload?: Record<string, unknown>, options?: CommonClientApi.BrowserCallOptions) => Promise<ConfigurationServiceApi.Http.GetWhatsNew.Response>;
  };
}

const registry = {
  "auth": registerBrowserService("auth", {
      logout: { method: "POST", path: "/logout", token: "master" as const },
      generateCompanyToken: { method: "POST", path: "/token/generate", token: "master" as const },
      generateConsoleToken: { method: "POST", path: "/console/token/generate", token: "master" as const },
      updateMyself: { method: "PATCH", path: "/me", token: "master" as const },
      changeMyPassword: { method: "PATCH", path: "/me/password", token: "master" as const },
      getMyConfiguration: { method: "GET", path: "/me", token: "master" as const }
  }),
  "configuration": registerBrowserService("configuration", {
      getActiveCompaniesForUser: { method: "GET", path: "/me/companies", token: "master" as const },
      getWhatsNew: { method: "GET", path: "/whats-new", token: "master" as const }
  }),
};

export const browserMasterApi = createBrowserClient(registry) as unknown as BrowserMasterApiClient;
